import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { useFormContext, FormProvider } from "react-hook-form";
import { common, input, overview } from "../../../../../../i18n";
import { AddEmissionContext } from "../../../../../../contexts/AddEmissionContext";
import NumericField from "../../../../../../components/input/NumericField";

const AddSepticTank = () => {
  const { t } = useTranslation([common, overview, input], {
    nsMode: "fallback",
  });

  const stepTwoForm = useFormContext();

  const { isDisabledAuxInput } = AddEmissionContext();

  return (
    <FormProvider {...stepTwoForm}>
      <Grid item xs={12} md={6}>
        <NumericField
          size="small"
          name="amount"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          disabled
          label={t("amount-of-population-load")}
          placeholder={t("to-be-calculated")}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux2"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={0}
          label={t("Person-On-site")}
          placeholder={t("Person-On-site")}
          fullWidth
          disabled={isDisabledAuxInput}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux3"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={0}
          label={t("Actual-Working-Days")}
          placeholder={t("Actual-Working-Days-Desc")}
          fullWidth
          disabled={isDisabledAuxInput}
          info={t("Actual-Working-Days-Helper")}
        />
      </Grid>
    </FormProvider>
  );
};

export default AddSepticTank;
